import React from 'react';
import { Mutex } from '@src/helper/mutex';
import axios from 'axios';
import { sleep } from '@hfzq/crab-utils';

export * from './pdf-ctx';

export const PdfView = React.lazy(() => import('./pdf-view'));

const reactLazyMutex = new Mutex();

/**
 * 加载pdfview
 * 不允许并发执行
 */
export async function loadPdfView(loadPdfWorkFlag?: boolean) {
  await reactLazyMutex.acquire();
  await sleep(3000);
  if (loadPdfWorkFlag) {
    await loadPdfWork();
  }
  try {
    return await import('./pdf-view');
  } finally {
    reactLazyMutex.release();
  }
}

const loadPdfWork = async () => {
  await axios.get('./pdf.worker.min.js');
};
